import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

import App from './App';
import { store } from './store';
import { ConfigProvider } from './contexts/ConfigContext';
import { BASE_PATH } from '@/config/app-constants';
import ErrorBoundary from '@/ui-component/ErrorBoundary';
import ErrorPage from '@/views/pages/maintenance/Error';

const AppRoot = () => (
    <Provider store={store}>
        <ConfigProvider>
            <BrowserRouter basename={BASE_PATH}>
                <ErrorBoundary fallback={<ErrorPage mode="generic" showReload />}>
                    <App />
                </ErrorBoundary>
            </BrowserRouter>
        </ConfigProvider>
    </Provider>
);

export default AppRoot;
